export const RELEASE_ENVIRONMENT_SLUGS = [
  'dev',
  'staging',
  'production',
  'internal',
] as const;

export type ReleaseEnvironmentSlug =
  (typeof RELEASE_ENVIRONMENT_SLUGS)[number];

const ENVIRONMENT_VISIBILITY_KEY_PREFIX = 'cindro.hidden-environments';

function environmentVisibilityKey(
  organizationId: string,
  projectId: string
) {
  return `${ENVIRONMENT_VISIBILITY_KEY_PREFIX}:${organizationId}:${projectId}`;
}

export function readHiddenEnvironmentSlugs(
  storage: Pick<Storage, 'getItem'>,
  organizationId: string,
  projectId: string
) {
  if (!organizationId || !projectId) return new Set<string>();

  try {
    const raw = storage.getItem(
      environmentVisibilityKey(organizationId, projectId)
    );
    const parsed = raw ? JSON.parse(raw) : [];
    if (!Array.isArray(parsed)) return new Set<string>();
    return new Set(
      parsed.filter(
        (slug): slug is string =>
          typeof slug === 'string' &&
          RELEASE_ENVIRONMENT_SLUGS.includes(
            slug as ReleaseEnvironmentSlug
          )
      )
    );
  } catch {
    return new Set<string>();
  }
}

export function writeEnvironmentVisibility(
  storage: Pick<Storage, 'setItem'>,
  organizationId: string,
  projectId: string,
  hiddenSlugs: Iterable<string>
) {
  if (!organizationId || !projectId) return;
  const hidden = new Set(hiddenSlugs);
  storage.setItem(
    environmentVisibilityKey(organizationId, projectId),
    JSON.stringify(
      RELEASE_ENVIRONMENT_SLUGS.filter((slug) => hidden.has(slug))
    )
  );
}
